import { Col, Form, Input, Row } from 'antd';
import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDebouncedCallback } from 'use-debounce';
import { QuestionProps } from '../../../pages/form';

const { TextArea } = Input;

export const EmailQuestion: FC<QuestionProps> = ({ question, answer, onAnswer }) => {
  const { formatMessage } = useIntl();
  const locale = useRouter().locale;

  const emailQuestion = question?.email;
  const emailAnswer = answer?.value?.email?.value;

  const placeholder = formatMessage({ id: 'placeholder' });

  const [internalValue, setInternalValue] = useState<string>();

  useEffect(() => {
    if (emailAnswer !== internalValue) {
      setInternalValue(emailAnswer || undefined);
    }
  }, [emailAnswer]);

  const answerDebounced = useDebouncedCallback((value: string | undefined) => {
    onAnswer({
      email: {
        value: value,
      },
    });
  }, 400);

  function onChange(newValue: string | undefined) {
    setInternalValue(newValue);

    answerDebounced(newValue);
  }

  return (
    <Row>
      <Col>
        <Form.Item label={formatMessage({ id: 'question.email' })}>
          <TextArea
            size={'large'}
            rows={1}
            allowClear={false}
            placeholder={placeholder}
            value={internalValue}
            onChange={(e) => {
              onChange(e.target.value);
            }}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};
